module.exports = __webpack_public_path__ + "static/media/camille2.69f83525.jpg";